import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Plus, Edit, Trash2, Users, ChevronDown, Search, X } from "lucide-react";
import { api } from "../api/api";
import "../style/TerrenosPage.css";

function AddTerrenoModal({ open, onClose, onAdd }) {
    const [formData, setFormData] = useState({
        nombre: "",
        ubicacion: "",
        area_m2: "",
        descripcion: ""
    });

    useEffect(() => {
        if (!open) {
            setFormData({ nombre: "", ubicacion: "", area_m2: "", descripcion: "" });
        }
    }, [open]);

    const handleSubmit = async () => {
        if (!formData.nombre) {
            alert("El nombre es obligatorio");
            return;
        }

        try {
            const res = await api.createTerreno(formData);
            if (res.success) {
                alert("✅ Terreno creado exitosamente");
                onAdd();
                onClose();
            } else {
                alert("❌ " + (res.message || "Error al crear terreno"));
            }
        } catch (err) {
            console.error(err);
            alert("❌ Error al crear terreno");
        }
    };

    if (!open) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Agregar Terreno</h2>
                    <button onClick={onClose} className="close-btn">
                        <X size={24} />
                    </button>
                </div>

                <div className="modal-body">
                    <div className="form-group">
                        <label>Nombre *</label>
                        <input
                            type="text"
                            value={formData.nombre}
                            onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                            className="form-input"
                            placeholder="Ej: Campo Norte"
                        />
                    </div>

                    <div className="form-group">
                        <label>Ubicación</label>
                        <input
                            type="text"
                            value={formData.ubicacion}
                            onChange={(e) => setFormData({ ...formData, ubicacion: e.target.value })}
                            className="form-input"
                            placeholder="Ej: Medellín, Antioquia"
                        />
                    </div>

                    <div className="form-group">
                        <label>Área (m²)</label>
                        <input
                            type="number"
                            value={formData.area_m2}
                            onChange={(e) => setFormData({ ...formData, area_m2: e.target.value })}
                            className="form-input"
                            placeholder="Ej: 5000"
                        />
                    </div>

                    <div className="form-group">
                        <label>Descripción</label>
                        <textarea
                            value={formData.descripcion}
                            onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                            className="form-input"
                            rows={3}
                            placeholder="Descripción del terreno..."
                        />
                    </div>
                </div>

                <div className="modal-footer">
                    <button onClick={onClose} className="btn-cancel">
                        Cancelar
                    </button>
                    <button onClick={handleSubmit} className="btn-primary">
                        Crear Terreno
                    </button>
                </div>
            </div>
        </div>
    );
}

function EditTerrenoModal({ open, onClose, terreno, onEdit }) {
    const [formData, setFormData] = useState({
        nombre: "",
        ubicacion: "",
        area_m2: "",
        descripcion: ""
    });

    useEffect(() => {
        if (terreno) {
            setFormData({
                nombre: terreno.nombre || "",
                ubicacion: terreno.ubicacion || "",
                area_m2: terreno.area_m2 || "",
                descripcion: terreno.descripcion || ""
            });
        }
    }, [terreno]);

    const handleSubmit = async () => {
        if (!formData.nombre) {
            alert("El nombre es obligatorio");
            return;
        }

        try {
            const res = await api.updateTerreno(terreno.id, formData);
            if (res.success) {
                alert("✅ Terreno actualizado");
                onEdit();
                onClose();
            } else {
                alert("❌ " + (res.message || "Error al actualizar terreno"));
            }
        } catch (err) {
            console.error(err);
            alert("❌ Error al actualizar terreno");
        }
    };

    if (!open || !terreno) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Editar Terreno</h2>
                    <button onClick={onClose} className="close-btn">
                        <X size={24} />
                    </button>
                </div>

                <div className="modal-body">
                    <div className="form-group">
                        <label>Nombre *</label>
                        <input
                            type="text"
                            value={formData.nombre}
                            onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <label>Ubicación</label>
                        <input
                            type="text"
                            value={formData.ubicacion}
                            onChange={(e) => setFormData({ ...formData, ubicacion: e.target.value })}
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <label>Área (m²)</label>
                        <input
                            type="number"
                            value={formData.area_m2}
                            onChange={(e) => setFormData({ ...formData, area_m2: e.target.value })}
                            className="form-input"
                        />
                    </div>

                    <div className="form-group">
                        <label>Descripción</label>
                        <textarea
                            value={formData.descripcion}
                            onChange={(e) => setFormData({ ...formData, descripcion: e.target.value })}
                            className="form-input"
                            rows={3}
                        />
                    </div>
                </div>

                <div className="modal-footer">
                    <button onClick={onClose} className="btn-cancel">
                        Cancelar
                    </button>
                    <button onClick={handleSubmit} className="btn-primary">
                        Guardar Cambios
                    </button>
                </div>
            </div>
        </div>
    );
}
function ManageAccessModal({ open, onClose, terreno }) {
    const [miembros, setMiembros] = useState([]);
    const [grupos, setGrupos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [searching, setSearching] = useState(false);

    useEffect(() => {
        if (open && terreno) {
            fetchMiembros();
            setSearchQuery("");
            setSearchResults([]);
        }
    }, [open, terreno]);

    const fetchMiembros = async () => {
        setLoading(true);
        try {
            const res = await api.getTerrenoMiembros(terreno.id);
            if (res.success) {
                setMiembros(res.miembros_directos || []);
                setGrupos(res.grupos_vinculados || []);
            }
        } catch (err) {
            console.error("Error cargando miembros:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSearchClick = async () => {
        if (!searchQuery.trim()) {
            setSearchResults([]);
            return;
        }

        setSearching(true);
        try {
            const res = await api.searchUsuarios(searchQuery);
            console.log("Resultados búsqueda:", res);
            if (res.success) {
                const filtered = res.usuarios.filter(
                    u => !miembros.some(m => m.usuario_id === u.id)
                );
                setSearchResults(filtered);
            } else {
                setSearchResults([]);
            }
        } catch (err) {
            console.error("Error buscando usuarios:", err);
            setSearchResults([]);
        } finally {
            setSearching(false);
        }
    };

    const handleAddMember = async (usuario, rol) => {
        try {
            const res = await api.addTerrenoMiembro(terreno.id, {
                usuario_id: usuario.id,
                rol: rol
            });

            if (res.success) {
                alert(`✅ ${usuario.nombre} agregado como ${rol}`);
                setSearchQuery("");
                setSearchResults([]);
                fetchMiembros();
            } else {
                alert("❌ " + (res.message || "Error al agregar miembro"));
            }
        } catch (err) {
            console.error(err);
            alert("❌ Error al agregar miembro");
        }
    };

    const handleChangeRole = async (usuarioId, newRole) => {
        try {
            const res = await api.updateTerrenoMiembro(terreno.id, usuarioId, { rol: newRole });
            if (res.success) {
                alert("✅ Rol actualizado");
                fetchMiembros();
            } else {
                alert("❌ " + (res.message || "Error al cambiar rol"));
            }
        } catch (err) {
            console.error(err);
            alert("❌ Error al cambiar rol");
        }
    };

    const handleRemoveMember = async (usuarioId, nombre) => {
        if (!window.confirm(`¿Eliminar a ${nombre} del terreno?`)) return;

        try {
            const res = await api.deleteTerrenoMiembro(terreno.id, usuarioId);
            if (res.success) {
                alert("✅ Miembro eliminado");
                fetchMiembros();
            } else {
                alert("❌ " + (res.message || "Error al eliminar miembro"));
            }
        } catch (err) {
            console.error(err);
            alert("❌ Error al eliminar miembro");
        }
    };

    if (!open || !terreno) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content modal-large">
                <div className="modal-header">
                    <h2>Gestionar Acceso - {terreno.nombre}</h2>
                    <button onClick={onClose} className="close-btn">
                        <X size={24} />
                    </button>
                </div>

                <div className="modal-body">
                    <div className="search-section">
                        <label>Agregar Miembro</label>
                        <div className="search-input-container">
                            <input
                                type="text"
                                placeholder="Escribe nombre o email..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && handleSearchClick()}
                                className="form-input search-input"
                            />
                        </div>

                        <button
                            onClick={handleSearchClick}
                            disabled={searching}
                            className="btn-search"
                        >
                            <Search size={18} />
                            {searching ? 'Buscando...' : 'Buscar Usuario'}
                        </button>

                        {searching && (
                            <div className="loading-text">
                                🔍 Buscando usuarios...
                            </div>
                        )}

                        {!searching && searchQuery && searchResults.length === 0 && (
                            <div className="empty-search-message">
                                No se encontraron usuarios con "{searchQuery}"
                            </div>
                        )}

                        {searchResults.length > 0 && (
                            <div className="search-results">
                                <div className="search-results-header">
                                    <span>Selecciona un usuario y asigna un rol:</span>
                                </div>
                                {searchResults.map(usuario => (
                                    <div key={usuario.id} className="search-result-item">
                                        <div className="user-info">
                                            <div className="user-name">
                                                👤 {usuario.nombre} {usuario.apellido}
                                            </div>
                                            <div className="user-email">📧 {usuario.email}</div>
                                        </div>
                                        <div className="action-buttons">
                                            <button
                                                onClick={() => handleAddMember(usuario, 'viewer')}
                                                className="btn-role btn-viewer"
                                                title="Solo puede ver información"
                                            >
                                                👁️ Viewer
                                            </button>
                                            <button
                                                onClick={() => handleAddMember(usuario, 'editor')}
                                                className="btn-role btn-editor"
                                                title="Puede ver y editar"
                                            >
                                                ✏️ Editor
                                            </button>
                                            <button
                                                onClick={() => handleAddMember(usuario, 'admin')}
                                                className="btn-role btn-admin"
                                                title="Control total"
                                            >
                                                ⭐ Admin
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="members-section">
                        <h3>Miembros Directos ({miembros.length})</h3>

                        {loading ? (
                            <div className="loading-text">Cargando...</div>
                        ) : miembros.length === 0 ? (
                            <div className="empty-message">
                                No hay miembros. Agrega usuarios para compartir el acceso.
                            </div>
                        ) : (
                            <div className="members-list">
                                {miembros.map(miembro => (
                                    <div key={miembro.usuario_id} className="member-item">
                                        <div className="user-info">
                                            <div className="user-name">
                                                {miembro.nombre} {miembro.apellido}
                                            </div>
                                            <div className="user-email">{miembro.email}</div>
                                        </div>

                                        <div className="member-actions">
                                            <select
                                                value={miembro.rol}
                                                onChange={(e) => handleChangeRole(miembro.usuario_id, e.target.value)}
                                                className="role-select"
                                            >
                                                <option value="viewer">Viewer</option>
                                                <option value="editor">Editor</option>
                                                <option value="admin">Admin</option>
                                            </select>

                                            <button
                                                onClick={() => handleRemoveMember(miembro.usuario_id, miembro.nombre)}
                                                className="btn-icon btn-danger"
                                                title="Eliminar miembro"
                                            >
                                                <Trash2 size={18} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {grupos.length > 0 && (
                        <div className="groups-section">
                            <h3>Grupos Vinculados ({grupos.length})</h3>
                            <div className="groups-list">
                                {grupos.map(grupo => (
                                    <div key={grupo.grupo_id} className="group-item">
                                        <div className="group-info">
                                            <div className="group-name">🔗 {grupo.grupo_nombre}</div>
                                            <div className="group-permission">
                                                Permiso: {grupo.permiso === 'lectura_escritura' ? 'Lectura/Escritura' : 'Solo Lectura'}
                                            </div>
                                        </div>
                                        <div className="group-members-count">
                                            {grupo.miembros?.length || 0} miembros
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="modal-footer">
                    <button onClick={onClose} className="btn-cancel">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default function TerrenosPage() {
    const [isOpen, setIsOpen] = useState(false);
    const [terrenos, setTerrenos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [accessOpen, setAccessOpen] = useState(false);
    const [selectedTerreno, setSelectedTerreno] = useState(null);
    const [expandedId, setExpandedId] = useState(null);

    const fetchTerrenos = async () => {
        setLoading(true);
        try {
            const res = await api.getTerrenos();
            if (res.success) {
                setTerrenos(res.terrenos || []);
            } else {
                setTerrenos([]);
            }
        } catch (err) {
            console.error("Error cargando terrenos:", err);
            setTerrenos([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTerrenos();
    }, []);

    const handleDelete = async (id, nombre) => {
        if (!window.confirm(`¿Seguro que quieres eliminar "${nombre}"?`)) return;

        try {
            const res = await api.deleteTerreno(id);
            if (res.success) {
                alert("✅ Terreno eliminado");
                setTerrenos(prev => prev.filter(t => t.id !== id));
            } else {
                alert("❌ " + (res.message || "Error eliminando terreno"));
            }
        } catch (err) {
            console.error(err);
            alert("❌ Error eliminando terreno");
        }
    };

    return (
        <div className="dashboard-root dashboard-dark">
            <div className="sidebar-container">
                <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>

            <div className="dashboard-main">
                <Header isOpen={isOpen} setIsOpen={setIsOpen} />

                <div className="page-header">
                    <h1 className="page-title">🌱 Terrenos</h1>
                    <button
                        onClick={() => setModalOpen(true)}
                        className="add-terreno-btn btn-with-icon"
                    >
                        <Plus size={20} />
                        <span>Agregar Terreno</span>
                    </button>
                </div>

                <div className="dashboard-content">
                    <div className="terrenos-list-card">
                        <div className="terrenos-list-header">
                            <h3>Lista de Terrenos</h3>
                        </div>

                        <div className="terrenos-list">
                            {loading ? (
                                <div className="loading">Cargando terrenos...</div>
                            ) : terrenos.length === 0 ? (
                                <div className="no-data">
                                    No hay terrenos registrados. Agrega tu primer terreno.
                                </div>
                            ) : (
                                terrenos.map((terreno) => (
                                    <div key={terreno.id} className="terrenos-row">
                                        <div className="terrenos-main">
                                            <div className="terrenos-info">
                                                <div className="terrenos-header">
                                                    <div className="terrenos-name">{terreno.nombre}</div>
                                                    <button
                                                        onClick={() => setExpandedId(expandedId === terreno.id ? null : terreno.id)}
                                                        className="expand-btn"
                                                    >
                                                        <ChevronDown
                                                            size={20}
                                                            className={expandedId === terreno.id ? 'rotated' : ''}
                                                        />
                                                    </button>
                                                </div>

                                                <div className="terrenos-meta">
                                                    <span>📍 {terreno.ubicacion || "Sin ubicación"}</span>
                                                    <span>📏 {terreno.area_m2 ? `${terreno.area_m2} m²` : "Sin área"}</span>
                                                </div>

                                                {terreno.descripcion && (
                                                    <div className="terrenos-desc">{terreno.descripcion}</div>
                                                )}
                                            </div>

                                            <div className="terrenos-actions">
                                                <button
                                                    onClick={() => {
                                                        setSelectedTerreno(terreno);
                                                        setEditOpen(true);
                                                    }}
                                                    title="Editar terreno"
                                                    className="action-btn edit-btn"
                                                >
                                                    <Edit size={18} />
                                                </button>

                                                <button
                                                    onClick={() => {
                                                        setSelectedTerreno(terreno);
                                                        setAccessOpen(true);
                                                    }}
                                                    title="Gestionar acceso"
                                                    className="action-btn access-btn"
                                                >
                                                    <Users size={18} />
                                                </button>

                                                <button
                                                    onClick={() => handleDelete(terreno.id, terreno.nombre)}
                                                    title="Eliminar terreno"
                                                    className="action-btn delete-btn"
                                                >
                                                    <Trash2 size={18} />
                                                </button>
                                            </div>
                                        </div>

                                        {expandedId === terreno.id && (
                                            <div className="terrenos-expanded">
                                                <div className="expanded-info">
                                                    <div className="info-item">
                                                        <span className="info-label">Fecha de creación:</span>
                                                        <span className="info-value">
                                                            {terreno.fecha_creacion
                                                                ? new Date(terreno.fecha_creacion).toLocaleDateString('es-ES')
                                                                : "N/A"}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">ID:</span>
                                                        <span className="info-value">{terreno.id}</span>
                                                    </div>
                                                    {terreno.rol && (
                                                        <div className="info-item">
                                                            <span className="info-label">Tu rol:</span>
                                                            <span className="info-value role-badge">{terreno.rol}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <AddTerrenoModal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
                onAdd={fetchTerrenos}
            />

            <EditTerrenoModal
                open={editOpen}
                onClose={() => setEditOpen(false)}
                terreno={selectedTerreno}
                onEdit={fetchTerrenos}
            />

            <ManageAccessModal
                open={accessOpen}
                onClose={() => setAccessOpen(false)}
                terreno={selectedTerreno}
            />
        </div>
    );
}